import axios from '@vtblife/axios';
import { cachedRequest, cmsDataUrlByEnvironmentMap } from '@vtblife/block-kit-utils';
export async function fetchQuizIndexData({ key, environment, }) {
    const { data } = await cachedRequest(key, async () => axios.get(`${cmsDataUrlByEnvironmentMap[environment]}/json/quiz-index.json`));
    return data;
}
//# sourceMappingURL=fetch-quiz-index-data.js.map